import './App.css';
import Navbar from './components/Navbar/navbar';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import About from './pages/About/About';
import Contact from './pages/Contact/Contact';
import Projects from './pages/Projects/Projects';
import Home from './pages/Home/Home';
import SocialBar from './components/SocialBar/SocialBar';
import References from './pages/References/References';
import LoadingScreen from './components/LoadingScreen/LoadingScreen';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { useState, useEffect } from 'react';

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Örnek: 2 saniye sonra loading bitiyor
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <LoadingScreen />;

  return (
    <Router>
      <Navbar />
      <SocialBar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/References" element={<References />} />
      </Routes>
    </Router>
  );
}

export default App;
